import type { FC } from "react"

import styles from "./SaveButton.module.scss"

import SaveIcon from "@/lib/images/SaveIcon"

type SaveButtonProps = {
	onClick: () => void
	disabled?: boolean
	loading?: boolean
	label?: string
	loadingLabel?: string
}

const SaveButton: FC<SaveButtonProps> = ({
	onClick,
	disabled,
	loading,
	label = "保存",
	loadingLabel = "保存中...",
}) => {
	return (
		<button
			type="button"
			className={styles.button}
			onClick={onClick}
			disabled={disabled || loading}
		>
			<SaveIcon />
			{loading ? loadingLabel : label}
		</button>
	)
}

export default SaveButton
